import { Banner, Text } from "@towersystems/roam-common-native";
import { useTranslation } from "../../../../utilities/i18n";

export interface MatchingProductBannerProps {
  onPress: () => void | Promise<void>;
  stockNumber: string;
}
export const MatchingProductBanner = ({
  onPress,
  stockNumber,
}: MatchingProductBannerProps) => {
  const { t } = useTranslation("invoice_arrival");
  return (
    <Banner
      title={t("banner.matching_product.title")}
      status="warning"
      onPress={onPress}
    >
      <Text>
        {t("banner.matching_product.description", {
          stock_number: stockNumber,
        })}
      </Text>
      <Text>{`Product with stock number ${stockNumber} already exists in system. Click here to add to invoice.`}</Text>
    </Banner>
  );
};
